import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { ProductCategory } from '@warema/shared/company-search/models';
import { DataUtilities } from '@warema/shared/utilities';
import * as ProductCategoryActions from './product-category.actions';

export const productCategoriesAdapter: EntityAdapter<ProductCategory> = createEntityAdapter<ProductCategory>();

export interface ProductCategoryState extends EntityState<ProductCategory> {
    selectedIds: [];
}

const initialState: ProductCategoryState = productCategoriesAdapter.getInitialState({
    selectedIds: [],
});

export const productCategoriesReducer = createReducer(
    initialState,

    on(ProductCategoryActions.ProductCategoriesLoaded, (state, { productCategories }): ProductCategoryState =>
        productCategoriesAdapter.setAll(productCategories, { ...state }),
    ),

    on(ProductCategoryActions.SubProductCategoriesSelected, (state, { ids }): ProductCategoryState => {
        const productCategories = DataUtilities.deepCopy(Object.values(state.entities));
        const updateEntities = productCategories
            .filter(x => x != null)
            .map(p => {
                p.productCategories.forEach(x => {
                    x.selected = ids.includes(x.id);
                });
                return p;
            })
            .map(p => ({ id: p.id, changes: p }));

        return productCategoriesAdapter.updateMany(updateEntities, { ...state });
    }),

    on(ProductCategoryActions.ActivateOnlyOneSubCategory, (state, { subProductCategoryId }): ProductCategoryState => {
        const productCategories = DataUtilities.deepCopy(Object.values(state.entities));
        const updateEntities = productCategories
            .filter(x => x != null)
            .map(p => {
                p.productCategories.forEach(x => {
                    x.selected = x.id === subProductCategoryId;
                });
                return p;
            })
            .map(p => ({ id: p.id, changes: p }));

        return productCategoriesAdapter.updateMany(updateEntities, { ...state });
    }),

    on(ProductCategoryActions.deselectAllProductSubCategories, (state): ProductCategoryState => {
        const productCategories = DataUtilities.deepCopy(Object.values(state.entities));
        const updateEntities = productCategories
            .filter(x => x != null)
            .map(p => {
                p.productCategories.forEach(x => {
                    x.selected = false;
                });
                return p;
            })
            .map(p => ({ id: p.id, changes: p }));

        return productCategoriesAdapter.updateMany(updateEntities, { ...state });
    }),
);

export function reducer(state: ProductCategoryState | undefined, action: Action): ProductCategoryState {
    return productCategoriesReducer(state, action);
}
